import styled from "styled-components";

export const DeviceGroupManagementWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: 100%;
    position: relative;
`;

export const ToolBarWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0px;
`;

export const ToolBarLeftWrapper = styled.div`
    flex: 0 0 auto;
`;

export const ToolBarRightWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
`;

export const TreeWrapper = styled.div`
    flex: 1 1 auto;
    border-radius: 5px;
    overflow-y: auto;
    background: #fff;
`;

export const TreeContentWrapper = styled.div`
    display: flex;
    height: 100%;
`;

export const LeftPanelWrapper = styled.div`
    flex: 0 0 300px;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #e8e8e8;
    padding-right: 10px;
`;

export const RightPanelWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    padding-left: 20px;
    min-width: 0;
`;

export const PanelTitle = styled.div`
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e8e8e8;
`;
